/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ChipInputComponent} from './chip-input.component';
import {ChipModule} from '../chip/chip.module';
import {InputModule} from '../input/input.module';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [ChipInputComponent],
    imports: [
        CommonModule,
        ChipModule,
        TooltipModule,
        InputModule
    ],
    exports: [
        ChipInputComponent
    ]
})
export class ChipInputModule {
}
